import GymActivityPlot from "/src/GymActivityPlot";
import * as React from 'react';
export default {
  GymActivityPlot,
  React
};